import React, { FC, useRef, useState, useEffect } from "react";
import styles from "./why-card.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const WhyCardSlider: FC = () => {
  const sliderRef = useRef<Slider>(null);

  const next = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const previous = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green" }}
        onClick={onClick}
      />
    );
  }
  const [containerClass, setContainerClass] = useState("");
  const [number, setNumber] = useState(3);

  const handleResize = () => {
    if (window.innerWidth < 577) {
      setNumber(1);
    } else if (window.innerWidth < 769) {
      setNumber(2);
    } else {
      setNumber(3);
    }

    if (window.innerWidth < 992) {
      setContainerClass("container-fluid");
    } else {
      setContainerClass("container");
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: number,
    slidesToScroll: number,
    autoplay: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className={styles["slider_container"]}>
      <div className={`slider_box  ${containerClass} `}>
        <Slider ref={sliderRef} {...settings}>
          <div className="card_box d-flex flex-column justify-content-center align-items-center">
            <div className="content_box d-flex flex-column  align-items-center">
              <div className="num_rect">01</div>
                <img
                  className="icon_imgs"
                  src="assets/images/home/reason-why/round-money.svg"
                  alt="money"
                />
              <div className="content_title">價格公開化</div>
              <div className="content_text">
                因為看不到價格而對買綠電這件事卻步嗎？大創將綠電價格明朗化，
                讓購買綠電這件事不再有距離感，買綠電也不再是大公司的專利了。
              </div>
            </div>
          </div>

          <div className="card_box d-flex flex-column justify-content-center align-items-center">
            <div className="content_box d-flex flex-column  align-items-center">
              <div className="num_rect">02</div>
                <img
                  className="icon_imgs"
                  src="assets/images/home/reason-why/shake-hands.svg"
                  alt="shake-hands"
                />
              <div className="content_title">自由的選擇合作夥伴</div>
              <div className="content_text">
                想要自行選擇合作夥伴，卻找不到相性佳的對象嗎？
                我們提供商場讓買賣方自由選擇，自行選購合作對象與欲購買的量能；買綠電、用戶全程一同參與！
              </div>
            </div>
          </div>

          <div className="card_box d-flex flex-column justify-content-center align-items-center">
            <div className="content_box d-flex flex-column  align-items-center">
              <div className="num_rect">03</div>
                <img
                  className="icon_imgs"
                  src="assets/images/home/reason-why/customization.svg"
                  alt="customization"
                />
              <div className="content_title">客製化服務</div>
              <div className="content_text">
                在我們的商場中找不到您喜歡的用戶嗎？我們也準備了解決方案予您參考！歡迎加入我們以了解更多！
              </div>
            </div>
          </div>
        </Slider>
      </div>

      <div className="slider_btn_box">
        <button className="preBtn" onClick={previous}>
          <img src="/assets/images/slider/arrow_L.png" alt="" />
        </button>
        <button className="nextBtn" onClick={next}>
          <img src="/assets/images/slider/arrow_R.png" alt="" />
        </button>
      </div>
    </div>
  );
};

export default WhyCardSlider;
